import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeleteChannelModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/delete-channel.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useDeleteChargePointChannelContext } from '../../charge-point.context';
import { ChargePointChannelDeleteFormStep1Controller } from '../charge-point-channel-delete-form-step-1/charge-point-channel-delete-form-step-1.controller';

export interface ChargePointChannelDeleteFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<DeleteChannelModel, 'chargePointId' | 'channelId'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<DeleteChannelModel, 'chargePointId' | 'channelId'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelDeleteFormController = (
  props: ChargePointChannelDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteChargePointChannelContext();

  return (
    <MultiStepFormProvider<
      Pick<DeleteChannelModel, 'chargePointId' | 'channelId'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['channelId', 'chargePointId'],
          component: <ChargePointChannelDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
